import React from 'react'
import "../AboutGreenCell/aboutGreenCell.css"
// import intercityarrow from '../../../assets/images/arrow.svg'

// import './App.css';

function AboutGreenCell() {
     return (
        <>
            <section className='about_section'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="about_part">
                                <div className="left-part">
                                    {/* <h2>About Greencell  Mobility</h2> */}
                                    <p>GreenCell Mobility, backed by Eversource Capital, is India’s leading player in electric mass mobility. The company is at the forefront of delivering Electric Mobility-as-a-Service (eMaaS), offering affordable, eco-friendly, and on-demand shared transportation solutions.</p>
                                    <p className='mb-0'>NueGo, the intercity arm of Greencell, is India’s largest premium intercity electric bus service. Focused on sustainability and guest-centricity, NueGo operates a fleet of 300+ electric buses across 100+ cities pan India. With cutting-edge e-mobility technology, NueGo ensures a safe, punctual, and comfortable travel experience - seamlessly connecting people while reducing environmental impact</p>
                                </div>
                                <div className="right-part">                                   
                                    <ul>
                                        <li style={{  backgroundColor: '#FFECDB'}}>
                                            <h3>IntraCity Buses</h3>
                                            <p>Gross Cost Contracts</p>
                                            <a href="#"> Read More 
                                            {/* <img src={intercityarrow} alt='img'/>  </a> */}
                                            <img src={`${process.env.REACT_APP_IMAGEBASE_URL}/arrow.svg`} alt='img'/>  </a>

                                        </li>
                                        <li style={{  backgroundColor: '#D3F1EF'}}>
                                            <h3>
                                                {/* <img src={Neugo_logo} alt="neugo-logo" /> */}
                                                <img src={`${process.env.REACT_APP_IMAGEBASE_URL}/nuego_logo.svg`} alt="neugo-logo" />

                                             <span>InterCity</span> </h3>
                                            <p>Now, book intercity travel with us</p>
                                            <a href="https://nuego.in?source=gcm" target="_blank"> Book Now 
                                            {/* <img src={intercityarrow} alt='img'/>  */}
                                            <img src={`${process.env.REACT_APP_IMAGEBASE_URL}/arrow.svg`} alt='img'/>  

                                             </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default AboutGreenCell
